export const API_SERVER_URL = process.env.REACT_APP_API_URL
//export const API_SERVER_URL = "http://127.0.0.1:5000/"
//export const API_SERVER_URL = process.env.REACT_APP_API_URL
// export const API_SERVER_URL = "http://20.15.166.198:5000/"
//export const API_SERVER_URL = "http://20.15.166.198:5000/"
